module.exports = __webpack_public_path__ + "static/media/id-check.f9b3be76.svg";